import React, { useState } from 'react';
import '../../assets/styles/FAQ.css';

const faqs = [
  { q: 'How long does it take to build a website?',
    a: 'Starter sites are usually completed in about 2 weeks. Growth sites usually take 3-4 weeks. Authority projects with custom logic usually take 3-5 weeks depending on scope.' },
  { q: "What's included in your website design service?",
    a: 'Every package includes responsive development, launch setup, and post-launch support. Growth adds custom design, messaging guidance, local SEO, domain setup, and analytics. Authority adds custom functionality and a process audit.' },
  { q: 'Do you offer website maintenance?',
    a: 'Yes. Care Plans start at $149/mo and include backups, uptime monitoring, priority support, and up to 1 hour of small edits per month.' },
  { q: "Can you improve my website's SEO?",
    a: 'Yes. Starter includes basic on-page SEO. Growth and Authority include a stronger local SEO foundation for service-area businesses.' },
  { q: 'How much does a website cost?',
    a: 'Starter is $997, Growth is $1,997, and Authority starts at $3,500. Custom work beyond Authority is scoped after discovery.' },
  { q: 'Will my website be mobile-friendly?',
    a: 'Yes, every site is fully responsive and optimized for mobile devices.' },
  { q: 'What support do you offer after launch?',
    a: 'Starter includes 30 days, Growth includes 60 days, and Authority includes 90 days of post-launch support. Ongoing Care Plans are available after that.' },
];

const FAQSection = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="faq-section section">
      <div className="section-inner narrow">
        <p className="eyebrow centered">Questions</p>
        <h2 className="centered">Frequently asked</h2>

        <div className="faq-list">
          {faqs.map((faq, i) => (
            <div
              key={faq.q}
              className={`faq-item${open === i ? ' active' : ''}`}
            >
              <button
                className="faq-question"
                onClick={() => setOpen(open === i ? -1 : i)}
              >
                <span>{faq.q}</span>
                <span className="chev">{open === i ? '–' : '+'}</span>
              </button>
              {open === i && (
                <div className="faq-answer">
                  <p>{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
